import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Alert } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Localization from 'l18n/l18n';
import AuthUser from 'models/auth';
import React, { useState } from 'react';
import {Helmet} from 'react-helmet';
import Bg from '../../assets/images/bg.png';
import Logo from '../../assets/images/sihatec-logo.png';

const styles = {
  container: {
    alignItems: 'center',
    height: '100vh',
    backgroundImage: 'url(' + Bg + ')',
    backgroundSize: 'cover',

  },
};

const Img = styled('img')({
  marginleft: '-2000',
  maxWidth: 200,
  maxHeight: '100%',
  marginTop: 14,
});
const StyledTextField = styled(TextField)({
  border:'0 !important',
  borderRadius:0,
  background:'#eeeeee',
  width:'100%',
  '& .MuiOutlinedInput-root' : {
    '& fieldset': {            // - The <fieldset> inside the Input-root
      border:0 // - Set the Input border
    },
   
  }
});
export default function VerifyForgotPassword(props) {
  const { email } = props;
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [retypeNewPassword, setRetypeNewPassword] = useState('');
  const [error, setError] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    setError(false);
    setIsLoading(false);
    if (retypeNewPassword !== newPassword) {
      setError(['password', Localization.translate['passwords_dont_match']]);
      return;
    } else if (isNaN(code) || code.length !== 6) {
      setError(['code', Localization.translate['invalid_reset_password_code_format']]);
      return;
    } else if (String(newPassword).length < 6) {
      setError(['password', Localization.translate['weak_password']]);
    } else {
      setIsLoading(true);
      AuthUser.verifyForgotPassword(email, code, newPassword)
        .then(() => {
          setIsLoading(false);
          window.location.reload();
        })
        .catch(({ error, message }) => {
          setIsLoading(false);
 
          if (
            message === 'Code must be 6-digit unique integer.' ||
            message === 'Code must be exactly 6 digits.' ||
            message === 'Code must be exactly 6 digits.' 
          ) {
            setError([
              'code',
              Localization.translate['invalid_reset_password_code_format'],
            ]);
          } else if(message === 'verification_code_no_match') {
            setError([
              'code',
              Localization.translate['invalid_reset_password_code'],
            ]);
          }else{
          
            setError(['error',Localization.translate['error']]);
          }
        });
    }
  };
  const errorMessage = (!isLoading && error[0]==='error') ? <Alert severity='error' >{error[1]}</Alert> :'' ;

  return (
  <>
    <Helmet>
        <title>{`${Localization.translate['app_name']} | ${Localization.translate['change_password']}`}</title>
    </Helmet>
    <Container component="main"  maxWidth="100vw" style={styles.container}>
       <Img alt="logo" src={Logo} />
      <CssBaseline />
      <Box
          sx={{
            margin:'0 auto',
            marginTop: 6,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth:'40rem',
            
          }}>
            <Avatar sx={{ m: -10, bgcolor: 'primary.main', width:120, height:120}}>
            <PersonOutlineIcon sx={{fontSize:'5rem'}} />
          </Avatar>
        <Card variant="outlined" sx={{ minWidth: 275, py:6, padding: 7,borderRadius:'2rem' }}>
          <Typography
            component="h1"
            variant="h5"
            sx={{ textAlign: 'center', my: 6,fontWeight: 'bold' }}
            >
            {Localization.translate['change_password']}
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
            >
            <Grid container>

            <Grid item xs={12}>
            <Typography sx={ { mt: 2, ml: 1, fontWeight: 'bold' } }>
                    {Localization.translate['please_enter_verification_code_sent_by_email']}
                </Typography>
            <StyledTextField
              margin="normal"
              required
              fullWidth
              id="code"
              placeholder={Localization.translate['please_enter_verification_code_sent_by_email' ]}
              name="code"
              autoComplete="code"
              autoFocus
              error={error[0] === 'code'}
              helperText={error[0] === 'code' ? error[1] : ''}
              type="number"
              maxlength={6}
              minLength={6}
              onChange={(event) => {
                setCode(event.target.value);
              }}
              />
            </Grid>
            <Grid item xs={12}>
            <Typography sx={ { mt: 2, ml: 1, fontWeight: 'bold' } }>
                    {Localization.translate['enter_new_password']}
                </Typography>
            <StyledTextField
              margin="normal"
              required
              fullWidth
              name="new-password-one"
              placeholder={Localization.translate['enter_new_password']}
              type="password"
              id="new-password-one"
              autoComplete="new-password-one"
              error={error[0] === 'password'}
              helperText={error[0] === 'password' ? error[1] : ''}
              onChange={(event) => {
                setNewPassword(event.target.value);
              }}
            />
            </Grid>

            <Grid item xs={12}>
            <Typography sx={ { mt: 2, ml: 1, fontWeight: 'bold' } }>
                    {Localization.translate['re_enter_new_password']}
                </Typography>
            <StyledTextField
              margin="normal"
              required
              fullWidth
              name="new-password-two"
              placeholder={Localization.translate['re_enter_new_password']}
              type="password"
              id="new-password-two"
              autoComplete="new-password-two"
              error={error[0] === 'password'}
              helperText={error[0] === 'password' ? error[1] : ''}
              onChange={(event) => {
                setRetypeNewPassword(event.target.value);
              }}
              />
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              
              sx={ {  padding: '0.5rem 4rem',mt:4, boxShadow: 'none', borderRadius: 0, color: '#FFFFFF',} }
              >
              {Localization.translate['Next']}
            </Button>
            <Grid item xs={12}>
              {errorMessage}
              </Grid>
            <Grid container>
              <Grid item xs sx={{ textAlign: 'center', mt: 3 }}>
                <Link href={'/'} variant="body2" sx={{ textAlign: 'center' }}>
                  <ArrowForwardIcon sx={{ fontSize: 'small' }} />{' '}
                  {Localization.translate['back']}
                </Link>
              </Grid>
            </Grid>
            </Grid>
          </Box>
        </Card>
      </Box>
    </Container>
 </>
  );
}
